import { useRef } from "react"
import styled from "styled-components"
import { Type } from "theme/types"

const Input = styled.input`
  ${({ theme }: Type) => theme?.inputOtp}
`

function OtpInput({ setValue }: any) {

  const one = useRef<HTMLInputElement>(null)
  const two = useRef<HTMLInputElement>(null)
  const tree = useRef<HTMLInputElement>(null)
  const four = useRef<HTMLInputElement>(null)
  const five = useRef<HTMLInputElement>(null)
  const six = useRef<HTMLInputElement>(null)


  const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    const refs: Record<string, HTMLInputElement | null> = {
      one: one.current,
      two: two.current,
      tree: tree.current,
      four: four.current,
      five: five.current,
      six: six.current
    }
    const valueRefs = `${refs.one?.value}${refs.two?.value}${refs.tree?.value}${refs.four?.value}${refs.five?.value}${refs.six?.value}`
    setValue("otp", valueRefs)

    if (value.length > 0) {
      const index =
        name === 'one'
          ? 'two'
          : name === 'two'
            ? 'tree'
            : name === 'tree'
              ? 'four'
              : name === 'four'
                ? 'five'
                : name === 'five'
                  ? 'six'
                  : 'one'
      refs[index]?.focus()
    }
  }

  return (
    <div className="w-full flex justify-between text-black">
      <Input
        type="tel"
        ref={one}
        name="one"
        onChange={inputChange}
        className="mx-auto uppercase text-center saira"
        maxLength={1}
      />
      <Input
        type="tel"
        ref={two}
        name="two"
        onChange={inputChange}
        className="mx-auto uppercase text-center saira"
        maxLength={1}
      />
      <Input
        type="tel"
        ref={tree}
        name="tree"
        onChange={inputChange}
        className="mx-auto uppercase text-center saira"
        maxLength={1}
      />
      <Input
        type="tel"
        ref={four}
        name="four"
        onChange={inputChange}
        className="mx-auto uppercase text-center saira"
        maxLength={1}
      />
      <Input
        type="tel"
        ref={five}
        name="five"
        onChange={inputChange}
        className="mx-auto uppercase text-center saira"
        maxLength={1}
      />
      <Input
        type="tel"
        ref={six}
        name="six"
        onChange={inputChange}
        className="mx-auto uppercase text-center saira"
        maxLength={1}
      />
    </div>

  )
}

export default OtpInput